import { Link } from "#src/components/Router.tsx";
import tw from "#src/utils/tw.ts";

const HeaderLogo = (props) => (
  <Link
    {...props}
    className={tw(
      "inline-block h-[50px] max-w-[50%] overflow-hidden truncate align-top leading-[50px] text-baseGray no-underline! hover:text-baseGray [&_img]:inline [&_img]:cursor-pointer",
      props.className
    )}
  />
);

export default HeaderLogo;
